// How many counts to offer when neither the rate nor the product states a maximum. It is a limit on the
// dropdown, not on the tour: the provider prices any quantity asked of it, so the number is ours.
const MAX_LISTED_WITHOUT_LIMIT = 30;

const buildTourRateQuantities = (rate, value, fallbackMin, fallbackMax) => {
  const min = rate?.minQuantity ?? fallbackMin;
  const max = rate?.maxQuantity ?? fallbackMax;
  const from = Math.max(min || 1, 1);
  const listed = max ? Math.max(max, value) : Math.max(from + MAX_LISTED_WITHOUT_LIMIT - 1, value);
  const counts = [];
  for (let count = from; count <= listed; count += 1) {
    counts.push(count);
  }
  return counts;
};

export default buildTourRateQuantities;
